import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M17.693 20.239H6.308a2.55 2.55 0 0 1-2.547-2.547V6.307A2.55 2.55 0 0 1 6.308 3.76h11.385a2.55 2.55 0 0 1 2.547 2.547v11.385a2.55 2.55 0 0 1-2.547 2.547zM6.307 4.789a1.521 1.521 0 0 0-1.519 1.519v11.385a1.52 1.52 0 0 0 1.519 1.519h11.385a1.52 1.52 0 0 0 1.519-1.519V6.308a1.521 1.521 0 0 0-1.519-1.519z"
}), 'CheckboxEmpty');
//# sourceMappingURL=index.js.map